import { GzHeaderUiWebComponent } from './view/GzHeaderUiWebComponent';
import { GzHeaderWebComponent } from './component/GzHeaderWebComponent';
import { WEB_COMPONENT_GZ_HEADER } from '../../webcomponents.constants';

export { GzHeaderUiWebComponent, GzHeaderWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_HEADER, GzHeaderWebComponent);
